import React, { ChangeEvent, KeyboardEvent, RefObject } from 'react';

import { OutlinedInputProps, TextField } from '@material-ui/core';

import inputStyles from '../Input.module.scss';
import styles from './ChatInput.module.scss';

export interface ChatInputProps {
	/* Compulsory for accessibility, more here: https://material-ui.com/components/text-fields/#accessibility */
	id: string;
	disabled?: boolean;
	placeholder?: string;
	transparent?: boolean;
	onFocus?: () => void;
	onBlur?: () => void;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	value: any;
	onKeyPress: (event: KeyboardEvent<HTMLDivElement>) => void;
	onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
	inputRef?: RefObject<HTMLInputElement>;
}

export const ChatInput = ({
	id,
	disabled = false,
	onFocus,
	onBlur,
	onChange,
	value,
	transparent = false,
	onKeyPress,
	onKeyDown,
	inputRef,
	...rest
}: ChatInputProps) => {
	const classes = [styles['chat-input']];

	if (transparent) {
		classes.push(styles['chat-input--transparent']);
	}

	return (
		<TextField
			id={id}
			disabled={disabled}
			autoComplete="off"
			multiline
			minRows={1}
			maxRows={4}
			className={classes.join(' ')}
			value={value}
			onChange={onChange}
			onKeyPress={onKeyPress}
			onKeyDown={onKeyDown}
			InputProps={
				{
					className: styles['chat-input__container'],
					disableUnderline: true,
				} as Partial<OutlinedInputProps>
			}
			inputProps={{
				className: inputStyles['input'],
				onFocus,
				onBlur,
				ref: inputRef,
			}}
			{...rest}
		/>
	);
};
